import {AnalysisLines} from 'analysis/AnalysisLines'

export const AnalysisTab = () => {
    return <AnalysisLines/>
}
